import React from 'react'
import API from "../base/API";
import { setUser } from "./Auth";
import Storage from "../base/Storage";

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            auth: "/user/auth",
        });

        this.state = {
            loginData: {
                email: "",
                password: "",
            }
        }
    }

    onSubmit(evt) {
        this.api.request({
            route: "auth",
            data: this.state.loginData,
            success: (response) => {
                setUser(response.user);
                Storage.set("atoken", response.key);
                //eslint-disable-next-line
                location.reload();
            }
        });
        evt.preventDefault();
    }

    onChange(evt) {
        // Get protocol from state
        let newLoginData = this.state.loginData;

        // Update it's value
        newLoginData[evt.target.name] = evt.target.value;

        // Update vehicle in state
        this.setState({ loginData: newLoginData });
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <div className="login-panel panel panel-default">
                            <div className="panel-heading">
                                <h2 style={{ marginTop: 0, marginBottom: 0, textAlign: "center" }}>
                                    webTEST&nbsp;
                                        <small style={{ fontSize: "12px" }}>by TOPTEST s.r.o.</small>
                                </h2>
                            </div>
                            <div className="panel-body">
                               <form role="form" autoComplete={"false"} onSubmit={this.onSubmit.bind(this)}>
                                    <fieldset>
                                        <div className="form-group">
                                            <input type="email"
                                                className="form-control"
                                                placeholder="E-Mail"
                                                name="email"
                                                onChange={this.onChange.bind(this)}
                                                autoFocus={true} />
                                        </div>
                                        <div className="form-group">
                                            <input type="password"
                                                className="form-control"
                                                placeholder="Heslo"
                                                name="password"
                                                onChange={this.onChange.bind(this)} />
                                        </div>
                                        <input type="submit"  className="btn btn-md btn-success btn-block" value="Prihlásiť"/>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/auth/Login.js